import React, { useContext, useState } from 'react';

const CustomerDataContext = React.createContext();
export const CustomerDataProvider = ({ children }) => {
  const [customer, setCustomer] = useState('');

  return (
    <CustomerDataContext.Provider value={{ customer, setCustomer }}>
      {children}
    </CustomerDataContext.Provider>
  );
};

export default function useCustomerData() {
  const context = useContext(CustomerDataContext);
  return context;
}
